import { createTermTagManager } from '../../utils/createTermTagManager';

export const subsidizedMortgageTagManager = createTermTagManager({
  jsonQueryKey: 'is_subsidised_mortgage',
  id: 'subsidizedMortgage',
  label: 'Скидки 4%',
});
